import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";

export const DHIRAAGU__EVENT_CONTAINER__PRODUCT_CATALOGUE_ID__COLUMN_ID = "b0d5f4e5-5318-4408-b103-19c219a39b0c" as Uuid;

export const DHIRAAGU_PRODUCT_CATALOGUE_TEMPLATE_ID = "0bd5bde6-8216-4e01-81ac-c067fc350544" as Uuid;

export const DHIRAAGU__PRODUCT_CATALOGUE__NAME__COLUMN_ID = "99b55ec3-3087-435c-9a0d-a7cb6bd561c0" as Uuid;

export const DHIRAAGU__PRODUCT_CATALOGUE__DESCRIPTION__COLUMN_ID = "751a5585-c062-4062-b1ea-a5de54e0ecd1" as Uuid;

export const DHIRAAGU__EVENT__ENQUIRY__PRODUCT_CATALOGUE_ID__COLUMN_ID = "ea85a8a0-bd62-469a-a588-e9ebf1314053" as Uuid;

export const DHIRAAGU__EVENT__CALLS__PRODUCT_CATALOGUE_ID__COLUMN_ID = "c7e8f9a0-b1d2-4e3f-9a5b-6c7d8e9f0a1b" as Uuid;

export const DHIRAAGU__EVENT__SALES__PRODUCT_CATALOGUE_ID__COLUMN_ID = "f1a0ed2e-f333-4c18-84df-087c51d28496" as Uuid;

export enum ProductCategoryEnum {
    PREPAID = "0ff43aaa-ba90-4d14-94d5-e4fbd3d4399f",
    POSTPAID = "f5beac7e-07de-46cf-b713-a2b1e36f5553",
    FIXED_BROADBAND = "573cebb0-87bd-4247-9db9-b2a9e3a0d42e",
    MNP = "d146151e-9f52-4f74-b9d3-92c1712f2ef0",
    DEVICE = "8e5e99de-e4e3-4c25-8a45-f9eaf97ba807",
    VAS = "5d8f9b3c-64ac-42f9-b352-55b2c8bfdd42",
}

export const productCategories: Record<ProductCategoryEnum, {
    id: Uuid,
    displayName: string
}> = {
    [ProductCategoryEnum.PREPAID]: {
        id: ProductCategoryEnum.PREPAID as Uuid,
        displayName: "Prepaid"
    },
    [ProductCategoryEnum.POSTPAID]: {
        id: ProductCategoryEnum.POSTPAID as Uuid,
        displayName: "Postpaid"
    },
    [ProductCategoryEnum.FIXED_BROADBAND]: {
        id: ProductCategoryEnum.FIXED_BROADBAND as Uuid,
        displayName: "Fixed Broadband (FBB)"
    },
    [ProductCategoryEnum.MNP]: {
        id: ProductCategoryEnum.MNP as Uuid,
        displayName: "Mobile Number Portability (MNP)"
    },
    [ProductCategoryEnum.DEVICE]: {
        id: ProductCategoryEnum.DEVICE as Uuid,
        displayName: "Device"
    },
    [ProductCategoryEnum.VAS]: {
        id: ProductCategoryEnum.VAS as Uuid,
        displayName: "VAS"
    },
};
